import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';
import type { TreatmentPlanV3TreatmentPageState } from './types';

export default function useTreatmentPlanV3TreatmentPageState(): TreatmentPlanV3TreatmentPageState {
  const treatmentPage = useSelector((state: RootState) => state.treatmentPlanV3.treatmentPage);
  const treatmentPageLoadCount = useSelector(
    (state: RootState) => state.treatmentPlanV3.treatmentPageLoadCount,
  );
  const hasLoaded = treatmentPage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.treatmentPageError != null,
  );
  const treatmentPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.treatmentPageLoading,
  );
  const isLoading = treatmentPageLoading || (!hasLoaded && !hasLoadError);
  const isUpdating = useSelector(
    (state: RootState) => state.treatmentPlanV3.updateTreatmentPageLoading,
  );

  return {
    treatmentPage,
    treatmentPageLoadCount,
    isLoading,
    hasLoadError,
    isUpdating,
  };
}
